export const FETCH_USERS_SEARCH_HISTORY_REQUEST = "FETCH_USERS_SEARCH_HISTORY_REQUEST";
export const FETCH_USERS_SEARCH_HISTORY_SUCCESS = "FETCH_USERS_SEARCH_HISTORY_SUCCESS";
export const FETCH_USERS_SEARCH_HISTORY_ERROR = "FETCH_USERS_SEARCH_HISTORY_ERROR";
